export const FACEBOOK_APP_ID = '674300627965093';
export const FACEBOOK_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
export const FACEBOOK_DEBUG_SDK_URL = 'https://connect.facebook.net/en_US/sdk/debug.js';
export const FACEBOOK_SDK_SCRIPT_TAG_ID = 'facebook-js-sdk';
export const STEPSTONE_FACEBOOK_LOGIN_API_URL = '/rlac/login-registration-service/oauth/Facebook/SignIn';
export const STEPSTONE_CSRF_TOKEN_API_URL = '/rlac/login-registration-service/Antiforgery/Token';
export const STEPSTONE_CSRF_TOKEN_COOKIE_NAME = 'XSRF-RLAC-TOKEN';
export const STEPSTONE_CSRF_HEADER_NAME = 'X-XSRF-RLAC-TOKEN';
//# sourceMappingURL=config.js.map